import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

interface ModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  fullScreenOnMobile?: boolean;
  wide?: boolean;
  extraWide?: boolean;
  /** When true, uses z-[9999] and portals to body so modal sits above header/footer on mobile */
  priorityZIndex?: boolean;
}

export function Modal({ title, onClose, children, fullScreenOnMobile = false, wide = false, extraWide = false, priorityZIndex = false }: ModalProps) {
  const maxWidthClass = extraWide ? 'md:max-w-5xl' : wide ? 'md:max-w-4xl' : 'md:max-w-2xl';
  const zClass = priorityZIndex ? 'z-[9999]' : 'z-50';
  
  const modalContent = (
    <div className={`fixed inset-0 min-h-[100dvh] bg-black/60 backdrop-blur-sm flex items-center justify-center ${zClass} ${fullScreenOnMobile ? 'p-0 md:p-4' : 'p-4'}`}>
      <div className={`bg-background ${fullScreenOnMobile ? `w-full h-full min-h-[100dvh] sm:min-h-0 md:w-auto md:h-auto md:max-h-[90vh] ${maxWidthClass} md:rounded-xl shadow-2xl` : `w-full ${maxWidthClass} max-h-[90vh] rounded-xl shadow-2xl`} overflow-hidden mx-auto flex flex-col`}>
        <div className={`sticky top-0 z-10 flex justify-between items-center ${fullScreenOnMobile ? 'px-4 py-4 md:px-8 md:py-6' : 'px-8 py-6'} border-b border-accent-text/10 bg-background`}>
          <h2 className={`${fullScreenOnMobile ? 'text-xl md:text-2xl' : 'text-2xl'} font-gelica font-semibold text-content`}>{title}</h2>
          <button 
            onClick={onClose}
            className="text-content/60 hover:text-content transition-colors p-2 hover:bg-accent-base/10 rounded-full"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        <div className={`flex-1 overflow-y-auto ${fullScreenOnMobile ? 'px-4 py-4 md:px-8 md:py-6' : 'px-8 py-6'}`}>
          {children}
        </div>
      </div>
    </div>
  );

  if (priorityZIndex && typeof document !== 'undefined') {
    return createPortal(modalContent, document.body);
  }
  return modalContent;
}